import { useEffect, useState } from 'react';
import { Modal } from 'react-daisyui';
import {
  VisitHistory,
  SchedulingActions,
  SchedulingHeader,
  CurrentVisit
} from 'components/TreatmentPlan';
import { Button } from 'components/Button';
import { connect } from 'react-redux';
import { TreatmentPlansActions } from 'store/actions';
import toast from 'react-hot-toast';

let enhancer = connect(null, { ...TreatmentPlansActions });

const SchedulingModal = ({ isOpen, onClose, treatmentPlan, onSchedule, getTreatmentPlanProgresses }) => {
  const { encoded_id: treatmentPlanId, active_treatment_plan_progress } = treatmentPlan || {}
  let { patient_request_type } = active_treatment_plan_progress || {}

  const [treatmentPlanProgresses, setTreatmentPlanProgresses] = useState(null)

  useEffect(() => {
    if (isOpen) loadTreatmentPlan()
    else setTreatmentPlanProgresses(null)
  }, [treatmentPlanId, isOpen]);

  const loadTreatmentPlan = async () => {
    try {
      const { data } = await getTreatmentPlanProgresses(treatmentPlanId);
      setTreatmentPlanProgresses(data);

    } catch (error) {
      toast.error(error.errors || 'Failed to load treatment plan');
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      backdrop
      className="max-w-xl rounded-3xl border-none shadow-2xl bg-white p-0 overflow-hidden"
    >
      <Modal.Body className="p-0 max-h-[90vh] flex flex-col overflow-hidden">
        <SchedulingHeader />

        <div className="flex-1 overflow-y-auto pb-6">
          <CurrentVisit
            patientRequestType={patient_request_type}
          />

          <SchedulingActions
            onClose={onClose}
            isLoadable={isOpen}
            treatmentPlan={treatmentPlan}
            onSchedule={onSchedule}
          />

          <div className="px-6 mt-4">
            <Button
              title="Cancel"
              variant="secondary"
              onClick={onClose}
              className='w-full !rounded-lg'
            />
          </div>

          <VisitHistory treatmentPlanProgresses={treatmentPlanProgresses} />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default enhancer(SchedulingModal);
